import { ReactElement } from 'react';
import PageNotFoundCharacters from '../assets/images/page-not-found-characters.png';
import styles from './not-found.page.module.scss';
import { UIButton, UIText } from '@/ui';
import { usePagesTranslation } from '../hooks';

export function NotFoundPage(): ReactElement {
    const { t } = usePagesTranslation();
    return (
        <div className={styles.page}>
            <img
                src={PageNotFoundCharacters}
                alt={t('pages.not_found.title')}
                className={styles.image}
            />
            <UIText variant="large" type="white">
                The page you are looking for has either moved or you do not have
                permission to view it
            </UIText>
            <UIButton
                variant="alternate"
                onClick={() => {
                    window.location.href = '/';
                }}
            >
                {t('pages.not_found.return_home')}
            </UIButton>
        </div>
    );
}
